// src/services/activityLogService.js
// =====================================================
// FuFund/FuMind_GM HR Module - Phase 3C Activity Log Service
// =====================================================
// Replace these placeholders with your Power Automate HTTP URLs.

const HR_ACTIVITY_LOG_GET_ALL_FLOW_URL = "/tracka-flow/v1/HR_ACTIVITY_LOG_GET_ALL";
const HR_ACTIVITY_LOG_CREATE_FLOW_URL = "/tracka-flow/v1/HR_ACTIVITY_LOG_CREATE";

const API_KEY = "";

async function parseJsonResponse(response) {
  try {
    return await response.json();
  } catch {
    return {};
  }
}

function normalizePowerAutomateResponse(rawData) {
  return rawData?.body || rawData || {};
}

function throwIfFlowFailed(response, data, fallbackMessage) {
  if (!response.ok || data?.success === false) {
    throw new Error(data?.message || fallbackMessage);
  }
}

export async function getHRActivityLogs(filters = {}) {
  if (!HR_ACTIVITY_LOG_GET_ALL_FLOW_URL || HR_ACTIVITY_LOG_GET_ALL_FLOW_URL === "PASTE_HR_ACTIVITY_LOG_GET_ALL_FLOW_URL_HERE") {
    throw new Error("HR Activity Log Get All flow URL is not configured in activityLogService.js");
  }

  const response = await fetch(HR_ACTIVITY_LOG_GET_ALL_FLOW_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({

      employeeId: filters.employeeId || "",
      workEmail: filters.workEmail || "",
      activityType: filters.activityType || "",
      activityStatus: filters.activityStatus || "",
      sourceModule: filters.sourceModule || ""
    })
  });

  const rawData = await parseJsonResponse(response);
  const data = normalizePowerAutomateResponse(rawData);
  throwIfFlowFailed(response, data, "Failed to load HR activity logs");

  return Array.isArray(data.activities) ? data.activities : [];
}

export async function createHRActivityLog(activity = {}) {
  if (!HR_ACTIVITY_LOG_CREATE_FLOW_URL || HR_ACTIVITY_LOG_CREATE_FLOW_URL === "PASTE_HR_ACTIVITY_LOG_CREATE_FLOW_URL_HERE") {
    throw new Error("HR Activity Log Create flow URL is not configured in activityLogService.js");
  }

  const response = await fetch(HR_ACTIVITY_LOG_CREATE_FLOW_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({

      activityId: activity.activityId || "",
      employeeId: activity.employeeId || "",
      workEmail: activity.workEmail || "",
      activityType: activity.activityType || "System Update",
      activityStatus: activity.activityStatus || "Success",
      activityBy: activity.activityBy || "system",
      activityDate: activity.activityDate || new Date().toISOString(),
      comments: activity.comments || "",
      sourceModule: activity.sourceModule || "System",
      oldStatus: activity.oldStatus || "",
      newStatus: activity.newStatus || ""
    })
  });

  const rawData = await parseJsonResponse(response);
  const data = normalizePowerAutomateResponse(rawData);
  throwIfFlowFailed(response, data, "Failed to create HR activity log");

  return data;
}
